<template>
<div class="page_transport">
  <div class="container py-5">
    <div class="page_topic_blcok my-4">
      <div class="topic_border">
        <p class="topic_eng">EXHIBITION SIGNUP</p>
        <p class="topic_cht">線上報名參展</p>
      </div>
    </div>
    <!-- 線上報名參展 -->
    <div class="member_block">
      <!--<h2>
        <img src="@/assets/icons/member_title.png" /> 線上報名參展
      </h2>-->
    </div>
    <div class="signup_sign_block">
      <p>
        <ul>
          <li>※ 大會將會以此報名表資訊作為審核的依據，<span style="color:red;">請詳細填寫下方報名表單</span>；系統收到您的申請資訊後將會發送「<span style="color:red;">參展資訊登錄成功信</span>」至<span style="color:red;">承辦人E-mail</span>中，請確認系統信中所示的<span style="color:red;">廠商資訊&amp;參展資訊</span>正確無誤。</li>
          <li>※ 若您要查詢您的報名紀錄，請選擇「<span style="color:red;">報名參展記錄</span>」查詢您的所有報名紀錄及進度。</li>
          <li>※ 若您有任何問題請洽詢您的責任業務，或與客服人員聯絡：電話：02-2759-7167、E-mail：CRM@top-link.com.tw。</li>
        </ul>
      </p>
      <!-- 廠商資訊 -->
      <div class="member_join_block">
        <div class="member_join_box">
          <h4>廠商資訊│請至「修改公司資訊」變更您的廠商資訊</h4>
          <div>
            <label>公司統編</label>
            <p>
              <span class="sub_label">01234567</span>
            </p>
          </div>
          <div>
            <label>公司/機關名稱</label>
            <p>
              <span class="sub_label">上聯國際展覽</span>
            </p>
          </div>
          <div>
            <label>負  責  人</label>
            <p>
              <span class="sub_label">時瑤如</span>
            </p>
            <p>
              <span class="sub_label">董事長</span>
            </p>
          </div>
          <div>
            <label>公司地址</label>
            <p>
              <span class="sub_label">11100</span> <span class="sub_label">台北市信義區忠孝東路五段550號4樓</span>
            </p>
          </div>
          <div>
            <label>連 絡 人</label>
            <div class="member_contract" style="padding-left:30px;">
              <p>
                <span class="sub_label">姓　　名</span>
                <span class="sub_label" style="padding-left:10px;">陳先生</span>
              </p>
              <p>
                <span class="sub_label">職　　稱</span>
                <span class="sub_label">企劃專員</span>
              </p>
              <p>
                <span class="sub_label">公司電話</span>
                <span class="sub_label">02-2756-7167</span>
              </p>
              <p>
                <span class="sub_label">手機號碼</span>
                <span class="sub_label">0912345678</span>
              </p>
              <p>
                <span class="sub_label">傳真號碼</span>
                <span class="sub_label"></span>
              </p>
              <p style="padding-left:15px;">
                <span class="sub_label">E-mail</span>
                <span class="sub_label">aaa@top-link.com.tw</span>
              </p>
            </div>
          </div>
        </div>
      </div><!--member_join_block END-->
      <!-- 填表範圍 -->
      <form>
        <!-- 參展資訊 -->
        <div class="member_join_block">
          <div class="member_join_box">
            <h4>參展資訊│「<span class="require_mark">*</span>」為必填項目</h4>
            <div>
              <label><span class="require_mark">*</span> 展場招牌名稱</label>
              <div style="margin-left:30px;">
                <p>
                  <input id="same_company_name" type="checkbox">
                  <label for="same_company_name" style="font-size:15px;">同公司名稱</label>
                  <span style="font-size:14px;">（勾選後系統會自動帶入會員資料中的公司名稱）</span>
                </p>
                <p>
                  <label style="color:#717171;font-weight:400;font-size:14.5px;">中　　文</label>
                  <input type="text" class="member_input member_input_md">
                </p>
                <p>
                  <label style="color:#717171;font-weight:400;font-size:14.5px;">英　　文</label>
                  <input type="text" class="member_input member_input_md">
                </p>
              </div>
            </div>
            <div>
              <label><span class="require_mark">* </span>承 辦 人</label>
              <div class="member_contract" style="margin-left:30px;">
                <p>
                  <input id="same_contact_person" type="checkbox">
                  <label for="same_contact_person" style="font-size:15px;">同連絡人</label>
                  <span style="font-size:14px;">（勾選後系統會自動帶入會員資料中的連絡人資訊）</span>
                </p>
                <p>
                  <label class="sub_label"><span class="require_mark">*</span> 姓　　名</label>
                  <input type="text" class="member_input member_input_md">
                </p>
                <p>
                  <label class="sub_label"><span class="require_mark">*</span> 職　　稱</label>
                  <input type="text" class="member_input member_input_md">
                </p>
                <p>
                  <label class="sub_label"><span class="require_mark">*</span> 公司電話</label>
                  <input type="text" class="member_input member_input_md">
                  <br>
                  <span style="font-size:14px;">（如有分機請以 #分機號碼 表示）</span>
                </p>
                <p>
                  <label class="sub_label"><span class="require_mark">*</span> 手機號碼</label>
                  <input type="text" class="member_input member_input_md">
                  <br>
                  <span style="font-size:14px;">（填寫範例：0912345678）</span>
                </p>
                <p>
                  <label class="sub_label"><span class="require_mark" style="visibility:hidden;">*</span> 傳真號碼</label>
                  <input type="text" class="member_input member_input_md">
                </p>
                <p style="padding-left:15px;">
                  <label class="sub_label"><span class="require_mark">*</span> E-mail</label>
                  <input type="email" class="member_input member_input_md">
                </p>
              </div>
            </div>
            <div>
              <label><span class="require_mark">*</span> 付款方式</label>
              <div style="margin-left:30px;">
                <p>
                  <input id="payment_remit" type="radio" name="payment" checked>
                  <label for="payment_remit" style="font-size:15px;">匯款</label>
                  <input id="payment_check" type="radio" name="payment">
                  <label for="payment_check" style="font-size:15px;">支票</label>
                </p>
              </div>
            </div>
            <div>
              <label><span class="require_mark">*</span> 發票統編</label>
              <div style="margin-left:30px;">
                <p>
                  <input id="same_company_no" type="checkbox">
                  <label for="same_company_no" style="font-size:15px;">同帳號/公司統編</label>
                  <span style="font-size:14px;">（勾選後系統會自動帶入廠商資訊中的帳號/公司統編）</span>
                </p>
                <p>
                  <input type="text" class="member_input member_input_sm">
                </p>
              </div>
            </div>
            <div>
              <label><span class="require_mark">*</span> 發票抬頭</label>
              <div style="margin-left:30px;">
                <p>
                  <input id="same_company_no_name" type="checkbox">
                  <label for="same_company_no_name" style="font-size:15px;">同公司/機關名稱</label>
                  <span style="font-size:14px;">（勾選後系統會自動帶入廠商資訊中的公司名稱）</span>
                </p>
                <p>
                  <input type="text" class="member_input member_input_sm">
                </p>
              </div>
            </div>
            <div>
              <label><span class="require_mark">*</span> 發票寄送地址</label>
              <div style="margin-left:30px;">
                <p>
                  <input id="same_company_address" type="checkbox">
                  <label for="same_company_address" style="font-size:15px;">同公司地址</label>
                  <span style="font-size:14px;">（勾選後系統會自動帶入廠商資訊中的公司地址）</span>
                </p>
                <p>
                  <input type="text" class="member_input member_input_xs">
                  <select class="member_input member_input_sm select">
                    <option value="0">請選擇</option>
                    <option value="0">台北市</option>
                    <option value="0">新北市</option>
                    <option value="0">新竹市</option>
                    <option value="0">台中市</option>
                    <option value="0">高雄市</option>
                  </select>
                  <select class="member_input member_input_sm select">
                    <option value="0">請選擇</option>
                    <option value="0">信義區</option>
                    <option value="0">大安區</option>
                    <option value="0">松山區</option>
                    <option value="0">中正區</option>
                  </select>
                  <input type="text" class="member_input member_input_md">
                </p>
              </div>
            </div>
          </div>
        </div><!--參展資訊 END-->
        <!-- 攤位資訊 -->
        <div class="member_join_block">
          <div class="member_join_box">
            <h4>攤位資訊│「<span class="require_mark">*</span>」為必填項目</h4>
            <div class="bd_bottom">
              <div>
                <label><span class="require_mark">*</span> 大會承辦人</label>
                <p>
                  <label for="sign_responsor_yes">
                    <input id="sign_responsor_yes" type="radio" name="responsor_exist" checked>有，
                    <select class="member_input member_input_sm select">
                      <option>選擇業務</option>
                      <option>其他(請填姓名)</option>
                    </select>

                    <input type="text" class="member_input member_input_md" placeholder="姓名：">
                  </label>
                  <br>
                  <input id="sign_responsor_no" type="radio" name="responsor_exist">
                  <label for="sign_responsor_no">無，請大會指派專人服務</label>
                </p>
              </div>
              <div style="display:none;"></div>
            </div>
            <!-- 1 -->
            <div class="bd_bottom">
              <div>
                <h6>
                  <input type="checkbox" id="exhibition01" style="visibility:hidden;">
                  <label for="exhibition01" style="margin-bottom:0;">
                    <span>台中</span> 2017.09.02~05 台中朝馬展覽館
                  </label>
                  <p style="display:inline-block;">已報名</p>
                </h6>
                <div>
                  <label>標準攤位：</label>
                  ＄<span>35,000</span>元 / 格（含稅、含基本裝潢）　申請格數：
                  <select>
                    <option v-for="n in num">{{ n-1 }}</option>
                  </select>格
                  <input type="radio" style="margin-left:20px;">委託大會基本裝潢
                  <input type="radio" style="margin-left:20px;">自行裝潢
                </div>
                <div style="display:none;">
                  <label>無隔間：</label>
                  ＄<span>30,000</span>元 / 格（含稅、含基本裝潢）　申請格數：
                  <select>
                    <option v-for="n in num">{{ n-1 }}</option>
                  </select>格
                  <input type="radio" style="margin-left:20px;">委託大會基本裝潢
                  <input type="radio" style="margin-left:20px;">自行裝潢
                </div>
                <div class="exhibit_type">
                  <label>展區分類：</label>
                  <div><input type="radio">A.<span>________</span>區</div>
                  <div><input type="radio">B.<span>________</span>區</div>
                  <div><input type="radio">C.<span>________</span>區</div>
                  <div><input type="radio">D.<span>________</span>區</div>
                </div>
              </div>
              <div>小計：<br>NT$ <span>70,000</span>元</div>
            </div>
            <!-- 2 -->
            <div class="bd_bottom">
              <div>
                <h6>
                  <input type="checkbox" id="exhibition01">
                  <label for="exhibition01" style="margin-bottom:0;">
                    <span>台北</span> 2017.09.02~05 台中朝馬展覽館
                  </label>
                  <p>已報名</p>
                </h6>
                <div>
                  <label>標準攤位：</label>
                  ＄<span>45,000</span>元 / 格（含稅、含基本裝潢）　申請格數：
                  <select>
                    <option v-for="n in num">{{ n-1 }}</option>
                  </select>格
                  <input type="radio" style="margin-left:20px;">委託大會基本裝潢
                  <input type="radio" style="margin-left:20px;">自行裝潢
                </div>
                <div>
                  <label>無隔間：</label>
                  ＄<span>40,000</span>元 / 格（含稅、含基本裝潢）　申請格數：
                  <select>
                    <option v-for="n in num">{{ n-1 }}</option>
                  </select>格
                  <input type="radio" style="margin-left:20px;">委託大會基本裝潢
                  <input type="radio" style="margin-left:20px;">自行裝潢
                </div>
                <div class="exhibit_type">
                  <label>展區分類：</label>
                  <div><input type="radio">A.<span>________</span>區</div>
                  <div><input type="radio">B.<span>________</span>區</div>
                  <div><input type="radio">C.<span>________</span>區</div>
                  <div><input type="radio">D.<span>________</span>區</div>
                </div>
              </div>
              <div>小計：<br>NT$ <span></span>元</div>
            </div>
            <!-- 3 -->
            <div class="bd_bottom">
              <div>
                <h6>
                  <input type="checkbox" id="exhibition01">
                  <label for="exhibition01" style="margin-bottom:0;">
                    <span>台中</span> 2017.09.02~05 台中朝馬展覽館
                  </label>
                  <p>已報名</p>
                </h6>
                <div>
                  <label>標準攤位：</label>
                  ＄<span>35,000</span>元 / 格（含稅、含基本裝潢）　申請格數：
                  <select>
                    <option v-for="n in num">{{ n-1 }}</option>
                  </select>格
                  <input type="radio" style="margin-left:20px;">委託大會基本裝潢
                  <input type="radio" style="margin-left:20px;">自行裝潢
                </div>
                <div style="display:none;">
                  <label>無隔間：</label>
                  ＄<span>30,000</span>元 / 格（含稅、含基本裝潢）　申請格數：
                  <select>
                    <option v-for="n in num">{{ n-1 }}</option>
                  </select>格
                  <input type="radio" style="margin-left:20px;">委託大會基本裝潢
                  <input type="radio" style="margin-left:20px;">自行裝潢
                </div>
                <div class="exhibit_type">
                  <label>展區分類：</label>
                  <div><input type="radio">A.<span>________</span>區</div>
                  <div><input type="radio">B.<span>________</span>區</div>
                  <div><input type="radio">C.<span>________</span>區</div>
                  <div><input type="radio">D.<span>________</span>區</div>
                </div>
              </div>
              <div>小計：<br>NT$ <span></span>元</div>
            </div>
            <!-- 4 -->
            <div class="bd_bottom">
              <div>
                <h6>
                  <input type="checkbox" id="exhibition01">
                  <label for="exhibition01" style="margin-bottom:0;">
                    <span>台北</span> 2017.09.02~05 台中朝馬展覽館
                  </label>
                  <p>已報名</p>
                </h6>
                <div>
                  <label>標準攤位：</label>
                  ＄<span>45,000</span>元 / 格（含稅、含基本裝潢）　申請格數：
                  <select>
                    <option v-for="n in num">{{ n-1 }}</option>
                  </select>格
                  <input type="radio" style="margin-left:20px;">委託大會基本裝潢
                  <input type="radio" style="margin-left:20px;">自行裝潢
                </div>
                <div>
                  <label>無隔間：</label>
                  ＄<span>40,000</span>元 / 格（含稅、含基本裝潢）　申請格數：
                  <select>
                    <option v-for="n in num">{{ n-1 }}</option>
                  </select>格
                  <input type="radio" style="margin-left:20px;">委託大會基本裝潢
                  <input type="radio" style="margin-left:20px;">自行裝潢
                </div>
                <div class="exhibit_type">
                  <label>展區分類：</label>
                  <div><input type="radio">A.<span>________</span>區</div>
                  <div><input type="radio">B.<span>________</span>區</div>
                  <div><input type="radio">C.<span>________</span>區</div>
                  <div><input type="radio">D.<span>________</span>區</div>
                </div>
              </div>
              <div>小計：<br>NT$ <span></span>元</div>
            </div>
            <!-- 5 -->
            <div class="bd_bottom">
              <div>
                <h6>
                  <input type="checkbox" id="exhibition01">
                  <label for="exhibition01" style="margin-bottom:0;">
                    <span>台中</span> 2017.09.02~05 台中朝馬展覽館
                  </label>
                  <p>已報名</p>
                </h6>
                <div>
                  <label>標準攤位：</label>
                  ＄<span>35,000</span>元 / 格（含稅、含基本裝潢）　申請格數：
                  <select>
                    <option v-for="n in num">{{ n-1 }}</option>
                  </select>格
                  <input type="radio" style="margin-left:20px;">委託大會基本裝潢
                  <input type="radio" style="margin-left:20px;">自行裝潢
                </div>
                <div style="display:none;">
                  <label>無隔間：</label>
                  ＄<span>30,000</span>元 / 格（含稅、含基本裝潢）　申請格數：
                  <select>
                    <option v-for="n in num">{{ n-1 }}</option>
                  </select>格
                  <input type="radio" style="margin-left:20px;">委託大會基本裝潢
                  <input type="radio" style="margin-left:20px;">自行裝潢
                </div>
                <div class="exhibit_type">
                  <label>展區分類：</label>
                  <div><input type="radio">A.<span>________</span>區</div>
                  <div><input type="radio">B.<span>________</span>區</div>
                  <div><input type="radio">C.<span>________</span>區</div>
                  <div><input type="radio">D.<span>________</span>區</div>
                </div>
              </div>
              <div>小計：<br>NT$ <span></span>元</div>
            </div>
            <!-- 注意事項 -->
            <p style="font-size:15px;color:red;max-width:680px;margin:20px auto;">注意事項：<br>
              <ol style="list-style-position:inside;margin:0;padding:0;">
                <li>以上報價為每一標準攤位3Mx3M（含基本裝潢及5％營業稅）。</li>
                <li>不含基本裝潢者，每一攤位退款新台幣2,000元整。</li>
                <li>若抽籤選位時，選至兩邊走道之攤位(角位)，每個角位另需加收新台幣3,000元整。</li>
                <li>以上標準攤位用不包含場地供電端至攤位內之電力佈線及器材費用(詳細訊息請洽大會裝潢公司)。</li>
                <li>以上價格若有疑問請洽詢您的責任業務。</li>
              </ol>
            </p>
            <!-- 總金額 -->
            <div class="total_count">
              <p>參展總金額：NT$ <span>70,000</span> 元</p>
            </div>
            <!-- 驗證碼 -->
            <div>
              <label for="member_join_verify"><span class="require_mark">* </span>驗證碼</label>
              <input class="member_input member_input_sm" id="member_join_verify" type="text" placeholder="請輸入右方數字" />
              <div style="display:inline-flex;width:80px;height:35px;border:1px solid black;align-items:center;justify-content:center;">
                <span><em>1547</em></span>
              </div>
              <div><a href="#">刷新驗證碼</a></div>
            </div>
            <div>
              <button class="submit_btn red" style="margin:15px auto;">確 認 送 出</button>
            </div>
          </div>
        </div>
      </form>
    </div><!--signup_sigh_block END-->
  </div>
</div>  
</template>

<script>
export default {
  data () {
    return{
      num: 11
    };
  }
}
</script>

<style>
.member_block>h2 {
  border-bottom:3px solid rgb(10, 116, 0);
  padding:4px 0;
}

.signup_sign_block>p {
  max-width:900px;
  margin:auto;
}
.signup_sign_block>p>ul {
  list-style-type:none;
  margin:20px auto;
  padding:0;
  font-size:15px;
}

.member_join_box>h4{
  background:rgba(255, 204, 102, 1);
  padding:8px 10px;
  font-weight:bold;
  color:#0000FF;
}


/* 共用設定 */
.member_join_box {
  margin:25px auto 0;
  max-width:992px;
}
.member_join_box>div {
  display:flex;
  justify-content:flex-start;
  align-items:baseline;
  flex-wrap:wrap;
}
.member_join_box div>label {
  font-weight:bold;
  width:120px;
  text-align:right;
  margin-bottom:none;
}
@media (max-width:550px){
  .member_join_box div>label {
    width:100%;
    text-align:left !important;
  }
}

.member_join_box>div p {
  padding-left:15px;
  margin-bottom:10px;
}

.member_input {
  height:35px;
  margin:0 3px;
  font-size:15px;
}
.member_input.member_input_xs {
  width:60px;
}
.member_input.member_input_sm {
  width:130px;
}
.member_input.member_input_md {
  width:200px;
}
.member_input.member_input_lg {
  width:400px;
}


.sub_label {
  width:71px;
  font-size:15px;
}

.require_mark {
  color:red;
}

.member_contract>p {
  margin:0 0 8px;
}

.member_contract>p>span:first-child {
  margin:0 0 8px;
  color:#717171;
  font-weight:400;
  font-size:14.5px;
}

.member_join_box .bd_bottom {
  border-bottom:2px dashed #cccccc;
  align-items:center;
}
.member_join_box .bd_bottom > div:nth-child(2){
  background:rgba(255, 255, 204, 1);
  padding:10px;
  font-weight:bold;
  margin-left:30px;
}

.bd_bottom {
  position:relative;
}
.bd_bottom>div:first-child {
  padding-right:130px;
}
.bd_bottom>div:last-child {
  position:absolute;
  right:0;
}
.bd_bottom div p{
  margin:0;
}
.bd_bottom h6 span{
  color:red;
  font-size:25px;
}
.bd_bottom h6 p{
  background-image: url('../../assets/signup/sign_hint.png');
  background-size: 100px 30px;
  width:100px;
  line-height:30px;
  text-align:center;
  display:none;
  color:red;
  font-weight:bold;
  padding-left:0;
}

.exhibit_type>div{
  display:inline-block;
}
.exhibit_type input{
  margin-left:20px;
}


.total_count {
  position:relative;
}
.total_count::after {
  content:' ';
  display:block;
  height:50px;
}
.total_count>p {
  position:absolute;
  right:0;
  background:rgba(255, 255, 204, 1);
  border:3px solid red;
  padding:7px 40px !important;
  text-align:center;
  font-weight:bold;
  font-size:19px;
}

/**page_topic**/
.page_topic_blcok { 
  display:inline-block; 
  text-align: right;
}
.page_topic_blcok .topic_border { 
  padding: 0px 1rem 1px 0;
  border-right:1px solid #d6d6d6; 
  font-size:2rem; 
  line-height:1.1;
}
.page_topic_blcok .topic_border .topic_eng { 
  color:#8c8c8d;
  line-height:1.5;
  margin:0;
}
.page_topic_blcok .topic_border .topic_cht { 
  color:#b0b0b0;
  line-height:1.5;
  letter-spacing:9px;
  margin-right:-9px; 
}

/* btn */
.submit_btn{
  outline:none;
  border:0;
  margin:0;
  padding:0;
  box-sizing: border-box;
}
.submit_btn.red{
  background: rgba(255, 0, 51, 1);
  color:white;
  width:140px;
  height:40px;
  border:1px solid rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
}
.submit_btn.blue{
  background: rgba(25, 158, 216, 1);
  color:white;
  width:140px;
  height:40px;
  border:1px solid rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/signup_sign.vue